import { render, staticRenderFns } from "./CreatePasswordPage.vue?vue&type=template&id=3bec20e2&scoped=true"
import script from "./CreatePasswordPage.vue?vue&type=script&lang=js"
export * from "./CreatePasswordPage.vue?vue&type=script&lang=js"
import style0 from "./CreatePasswordPage.vue?vue&type=style&index=0&id=3bec20e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec20e2",
  null
  
)

export default component.exports